"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalBody = void 0;
var _core = require("@emotion/core");
var _react = _interopRequireDefault(require("react"));
var _useTheme = require("../../../theme/utils/useTheme");
var _ScrollArea = require("../../scrollarea/components/ScrollArea");
var _modalTheme = require("../styled/modalTheme");
/** @jsxRuntime classic */
/** @jsx jsx */

/**
 * ModalBody is a component intended to be composed inside a Modal. It is responsible for:
 * - Rendering the main content area (aka the body) of a modal
 * - Providing a scrolling context for the modal body
 * - Locking browser scroll inside the modal, so the page doesn't scroll behind it
 * - Rendering an affordance that there's more content below the fold
 */
const ModalBody = _ref => {
  let {
    children,
    scrollContainerClientId,
    className
  } = _ref;
  const {
    key
  } = (0, _useTheme.useTheme)();
  const themeMode = key;
  return (0, _core.jsx)(_ScrollArea.ScrollArea, {
    className: className,
    clientId: scrollContainerClientId,
    gutter: _modalTheme.modalTheme.bodyGutter(themeMode),
    lockPageScroll: true
  }, children);
};
exports.ModalBody = ModalBody;
//# sourceMappingURL=ModalBody.js.map